import { Box, useTheme } from "@mui/material";
import { useEffect } from "react";

const AdCard = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  useEffect(() => {
    try {
      if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
        window.adsbygoogle.push({});
      }
    } catch (e) {
      console.error("Adsense error:", e);
    }
  }, []);

  return (
    <Box
      sx={{
        width: 280,
        height: 340,
        margin: 2,
        boxShadow: 3,
        borderRadius: 1,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: isDarkMode ? "#1e1e1e" : "#f9f9f9",
        border: isDarkMode ? "1px solid #333" : "1px solid #ddd",
      }}
    >
      <ins
        className="adsbygoogle"
        style={{ display: "block", width: "260px", height: "320px" }}
        data-ad-client="ca-pub-6545634854364065" // your AdSense client ID
        data-ad-slot="1234567890"               // replace with your actual Ad Slot ID
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </Box>
  );
};

export default AdCard;
